import {fubDeliveryDisplay} from '../shared/transfer-display';
import './fub-delivery.css';

export function FubDeliveryStatus({state}:{state:string|null|undefined}) {
  const status=fubDeliveryDisplay(state);
  return status?<div className={`fub-delivery-status ${status.needsAttention?'attention':''}`} role="status"><strong>{status.label}</strong><p>{status.detail}</p></div>:null;
}
